export default __webpack_public_path__ + "static/media/map_global_stewards.9ee58656.png";